import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import { useSelector } from "react-redux";
import ClientPortal from "./pages/ClientPortal";
import AdminLoginPage from "./pages/AdminLoginPage";
import AdminLayout from "./layouts/AdminLayout";
import AdminDashboardPage from "./pages/AdminDashboardPage";
import AdminUsersPage from "./pages/AdminUsersPage";
import AdminProfilePage from "./pages/AdminProfilePage";
import NotFoundPage from "./pages/NotFoundPage";
import ModalHost from "./components/ModalHost";
import { ToastHost } from "./components/RenderToast";
import { selectAuth } from "./store/authSlice";
import "./index.css";

function RequireAdmin() {
  const auth = useSelector(selectAuth);

  if (!auth.adminSession?.isAuthenticated) {
    return <Navigate to="/auth/admin/login" replace />;
  }

  return <Outlet />;
}

function AppRoutes() {
  return (
    <>
      <Routes>
        <Route path="/" element={<ClientPortal />} />
        <Route path="/client/:slug" element={<ClientPortal />} />
        <Route path="/auth/admin/login" element={<AdminLoginPage />} />
        <Route element={<RequireAdmin />}>
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<Navigate to="/admin/dashboard" replace />} />
            <Route path="dashboard" element={<AdminDashboardPage />} />
            <Route path="users" element={<AdminUsersPage />} />
            <Route path="profile-settings" element={<AdminProfilePage />} />
          </Route>
        </Route>
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
      <ModalHost />
      <ToastHost />
    </>
  );
}

function App() {
  return <AppRoutes />;
}

export default App;
